import React from 'react';
import { Link } from 'react-router-dom';
import BreadCrumb from '../components/BreadCrumb';
import Meta from '../components/Meta';

const PrivacyPolicy = () => {
  return (
    <>
      <div className=" bg-white overflow-hidden">
         <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/privacy.jpeg"
            alt="Privacy Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">Privacy Policy</h1>
            <p className="text-base text-gray-700 mt-4">
              LifeOnPlus is committed to protecting your personal information and your right to privacy. This Privacy Policy outlines how we collect, use, store, and protect your data.
            </p>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2"><strong>Personal Information:</strong> Name, phone number, email, address, age, gender, government ID, and medical records.</li>
              <li className="mb-2"><strong>Transaction Information:</strong> Payment methods, transaction history, and product/service usage.</li>
              <li className="mb-2"><strong>Device & Usage Data:</strong> IP address, browser details, app usage, and cookies.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Purpose of Collection</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">To provide and personalize our services.</li>
              <li className="mb-2">To manage your account and process orders.</li>
              <li className="mb-2">To comply with legal obligations and ensure platform security.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Sharing of Information</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">We do not sell or rent user data.</li>
              <li className="mb-2">Information may be shared with authorized service providers or regulators under compliance requirements.</li>
              <li className="mb-2">Data is anonymized where possible.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Security</h2>
            <p className="text-base text-gray-700 leading-7">
              We implement encryption, access controls, and regular audits to protect user data. However, no system is completely secure.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Data Retention</h2>
            <p className="text-base text-gray-700 leading-7">
              User data is retained as long as your account is active or as required by law.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Your Rights</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">You may access, update, or delete your data by writing to <a href="mailto:legal@lifeonplus.com" className="text-blue-600 hover:underline">legal@lifeonplus.com</a>.</li>
              <li className="mb-2">You may opt out of promotional communications anytime.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Third-Party Links</h2>
            <p className="text-base text-gray-700 leading-7">
              Our platform may link to third-party services not governed by this policy. LifeOnPlus is not responsible for their privacy practices.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Updates</h2>
            <p className="text-base text-gray-700 leading-7">
              We may update this policy periodically. Continued use constitutes agreement to the revised policy.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact</h2>
            <p className="text-base text-gray-700 leading-7">
              For queries or complaints, contact:
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              <strong>Legal/Grievance Officer</strong><br />
              Email: <a href="mailto:legal@lifeonplus.com" className="text-blue-600 hover:underline">legal@lifeonplus.com</a><br />
              Address: Lifeonplus Technologies India Private Limited, No.301, 3rd Floor, “Master Mind 1, Royal Palms”, Aarey Milk Colony, Goregaon (East), Mumbai-400065<br />
              Contact: 📞 <a href="tel:+919986880000" className="text-blue-600 hover:underline">99868 80000</a> | ✉️ <a href="mailto:info@lifeonplus.com" className="text-blue-600 hover:underline">info@lifeonplus.com</a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;